import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ y: 36, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export default Reveal;
